import { render, staticRenderFns } from "./view_edit_personel.vue?vue&type=template&id=2e86076a"
import script from "./view_edit_personel.vue?vue&type=script&lang=js"
export * from "./view_edit_personel.vue?vue&type=script&lang=js"
import style0 from "./view_edit_personel.vue?vue&type=style&index=0&id=2e86076a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports